import { format, isValid } from 'date-fns';
import { toast } from 'react-toastify';

const formatFiatCurrency = (value) => {
  if (!value) return '0.00';
  const numberValue = Number(value);
  const formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  });
  return formatter.format(numberValue).toString();
};
const formatCryptoCurrency = (value) => {
  if (!value) return '0.00000000';
  const numberValue = Number(value);
  const formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 8
  });
  return formatter.format(numberValue).toString();
};

const capitalize = (value) => {
  if (!value) return '';
  return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
};

const formatWallet = (value) => {
  if (!value) return '';
  if (value.length > 26) {
    let firstHalf = value.substring(0, 10);
    let secondHalf = value.substring(value.length - 10);
    return `${firstHalf}...${secondHalf}`;
  }
  return value;
};

const getValue = (item, columns) => {
  let value = item;
  for (const column of columns.split('/')) {
    if (!value) return null;
    value = value[column];
  }

  return value || '--';
};
const formatDate = (item, columns) => {
  const rawDate = columns ? getValue(item, columns) : item;

  if (rawDate === null || rawDate === undefined || rawDate === '' || rawDate === '--') {
    return '--';
  }

  const parsedDate = rawDate instanceof Date ? rawDate : new Date(rawDate);

  if (!isValid(parsedDate)) {
    return '--';
  }

  return format(parsedDate, 'dd-MM-yyyy');
};

const formatIconUrl = (icon_url, slug) => {
  return icon_url || `/coins/${slug.toLowerCase()}.svg`;
};

const formatValidationError = (data = []) => {
  let errorMessage = ``;
  const errorsArray = Object.entries(data);

  const noOfErrors = errorsArray.length;
  errorsArray.forEach((error, index) => {
    errorMessage += error[1].message;
    errorMessage += index < noOfErrors - 1 ? ', ' : '';
  });

  return errorMessage;
};

const formatErrorMessage = async (error) => {
  let message = await (formatValidationError(error?.response?.data?.data) ||
    error?.response?.data?.message ||
    error?.message);

  toast.error(message, {
    autoClose: 30 * 1000
  });
};

const formatTransactions = (data) => {
  const formattedData = data.map((tx) => {
    const { amount, currency } = tx;
    const { slug } = currency;
    const amount_currency = `${amount} ${slug.toUpperCase()}`;
    return {
      ...tx,
      amount_currency
    };
  });
  return formattedData;
};

const formatDocumentTitle = (title) => {
  return capitalize(title.replace(/_/g, ' '));
};

export {
  capitalize,
  formatCryptoCurrency,
  formatDate,
  formatDocumentTitle,
  formatErrorMessage,
  formatFiatCurrency,
  formatIconUrl,
  formatTransactions,
  formatWallet,
  getValue
};
